import React from "react";
import ReactDOM from "react-dom";
import "@picocss/pico";
import "./App.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Header,
  Footer,
  Home,
  About,
  Contact,
  UrlQrCodes,
  TextQrCodes,
  VcardQrCodes,
  PhoneQrCodes,
  SmsQrCodes,
  WhatsappQrCodes,
  UpiQrCodes,
  Privacy,
  Terms,
  Faqs,
  ScrollToTop,
  PageNotFound,
} from "./components";
import GA4React from "ga-4-react";
const ga4react = new GA4React("G-GG9LDJTM6K");
ga4react.initialize().then().catch();

ReactDOM.render(
  <Router>
    <ScrollToTop />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about/" element={<About />} />
      <Route path="/contact/" element={<Contact />} />
      <Route path="/url-qr-code/" element={<UrlQrCodes />} />
      <Route path="/text-qr-code/" element={<TextQrCodes />} />
      <Route path="/vcard-qr-code/" element={<VcardQrCodes />} />
      <Route path="/phone-qr-code/" element={<PhoneQrCodes />} />
      <Route path="/sms-qr-code/" element={<SmsQrCodes />} />
      <Route path="/whatsapp-qr-code/" element={<WhatsappQrCodes />} />
      <Route path="/upi-qr-code/" element={<UpiQrCodes />} />
      <Route path="/privacy-policy/" element={<Privacy />} />
      <Route path="/terms-conditions/" element={<Terms />} />
      <Route path="/faqs/" element={<Faqs />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
    <Footer />
  </Router>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
